
jQuery(document).ready(function ($) {

    $(document).scroll(function () {
        if ($(document).scrollTop() > 50) {
            $("#header").addClass("active")
            $("nav.menu").addClass("scrolled")
        } else {
            $("#header").removeClass("active")
            $("nav.menu").removeClass("scrolled")
        }
    });


    if( $('.age').length ){

        //localStorage.removeItem("MurgierVerified");
        const ls = localStorage.getItem('MurgierVerified');

        if(!ls){

            $('.age').addClass("active");

            const d = new Date();
            const today = d.getFullYear();

            const legal = 18;

            const date = {'n1':'0','n2':'0','n3':'0','n4':'0' };

            const dateMin = 1924;

            const checkDate = function(){
                const concat = date['n1']+date['n2']+date['n3']+date['n4'];

                if( $("#n1").val() && $("#n2").val() && $("#n3").val() && $("#n4").val() ){

                    if( (concat > dateMin) && ( (today - concat) >= legal ) ){
                        $('#submitAge').addClass("active");
                    }else{
                        $('#submitAge').removeClass("active");
                    }

                }

            }

            $('input[type="number"]').bind('focus', function () {
                $(this).val("");
            });

            $('input[type="number"]').bind('keyup', function () {
                //$(this).val() ;
                $(this).next().focus();
            });

            $('input[type="number"]').bind('input', function () {
                const key = $(this).attr('id');
                date[key] = $(this).val();
                checkDate();
            });

            $('#submitAge').on("click", function(e){
                e.preventDefault();
                localStorage.setItem('MurgierVerified',true);
                location.reload();
            });
        }

    }



})


